export default __webpack_public_path__ + "static/media/PlusIconBlue.0ea8f8a7.svg";